import {createUseStyles} from "react-jss";
import {input, label, space} from "../../theme";

export const useStyles = createUseStyles({
    component: {

    },
    label: {
      ...label,
    },
    options: {

    },
    input: {
        ...input,
    },
    divider: {
        marginInline: space(2),
    }
});